<span matSnackBarLabel style="z-index: 999999999999">
  <img *ngIf="image" [src]="image" class="img-fluid custom-image" style="height: 60px">
  {{data.message}}
</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">x</button>
</span>
